import React, { useState } from "react";
import "../styles/table.css";
import ExportToExcelBTN from "./ExportToExcelBTN";

const Table = ({ data, itemsPerPage }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [modalImage, setModalImage] = useState(null);

  const handleViewImage = (imageUrl) => {
    setModalImage(imageUrl);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pageCount = Math.ceil(data.length / itemsPerPage);
  const paginatedData = data.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <>
      <ExportToExcelBTN data={data} />
      <table className="table">
        <thead>
          <tr>
            <th>Branch</th>
            <th>UnitCode</th>
            <th>UnitName</th>
            <th>EmpCode</th>
            <th>ImgCount</th>
            <th>ImgUrl</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={index}>
              <td>{item.Branch}</td>
              <td>{item.UnitCode}</td>
              <td>{item.UnitName}</td>
              <td>{item.EmpCode}</td>
              <td>{item.RowCount}</td>

              <td>
                <button onClick={() => handleViewImage(item.ImgUrl)}>
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        {[...Array(pageCount)].map((_, i) => (
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            className={currentPage === i ? "active" : ""}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {modalImage && (
        <div className="modal" onClick={() => setModalImage(null)}>
          <span className="close">&times;</span>
          <img className="modal-content" src={modalImage} alt="Modal" />
        </div>
      )}
    </>
  );
};

export default Table;
